import { cn } from 'lib/helpers/utility';

const TableCell = ({ children, index, lastIdx, className, style, preview }) => {
  let cellClass = 'w-fit pt-3.5 pb-2.5 align-top items-start min-w-20 sm:min-w-0';
  if (index !== 0) cellClass += ' px-2';
  if (index === 0) cellClass += preview ? ' pl-2' : ' pl-7';

  return (
    <td className={cn(cellClass, className)} style={style}>
      <div className={index === lastIdx && 'flex justify-end text-end'}>{children}</div>
    </td>
  );
};

export default TableCell;
